import React from "react";
import { parseTextWithInlineCitation } from "@/shared/utils/helperFunctions";

const InlineCitationText = ({ children, className = "" }) => {
  const { text, href, label } = parseTextWithInlineCitation(children);

  return (
    <span className={className}>
      {text}
      {href ? (
        <>
          {" "}
          <a
            href={href}
            target="_blank"
            rel="noreferrer"
            className="text-secondary font-medium hover:underline"
          >
            {label}
          </a>
        </>
      ) : null}
    </span>
  );
};

export default InlineCitationText;
